import skizz from './core/index'
import './ajax/index'
import './collections/index'
import './dom/index'
import './event/index'
import './utils/index'

skizz.version = '0.1.0'

window.skizz = window.$ = skizz

/**
 * Export Skizz
 */
export default skizz
